import type { SnackbarAction } from 'components/SnackbarNotification/types';

import { generateSnackbarId, snackbarEventBus } from './eventBus';

export const snackbarService = {
    showSuccess: (message: string, action?: SnackbarAction) => {
        snackbarEventBus.emit({
            id: generateSnackbarId(),
            message,
            variant: 'success',
            action,
        });
    },
    showError: (message: string, action?: SnackbarAction) => {
        snackbarEventBus.emit({
            id: generateSnackbarId(),
            message,
            variant: 'error',
            action,
        });
    },
    showWarning: (message: string, action?: SnackbarAction) => {
        snackbarEventBus.emit({
            id: generateSnackbarId(),
            message,
            variant: 'warning',
            action,
        });
    },
    showInfo: (message: string, action?: SnackbarAction) => {
        snackbarEventBus.emit({
            id: generateSnackbarId(),
            message,
            variant: 'info',
            action,
        });
    },
};
